import { extractTextFromQuery } from '../../../utils/query';

export default {
  param: extractTextFromQuery,
  having: function (text) {
    // const words = text.trim().split(' ');

    if (text) {
      return {
        $or: [
          {
            activity: {
              $where: {
                description: {
                  $ilike: `%${text}%`
                }
              }
            }
          },
          {
            description: {
              $ilike: `%${text}%`
            }
          },
          {
            audience: {
              $ilike: `%${text}%`
            }
          },
          {
            objective: {
              $ilike: `%${text}%`
            }
          }
        ]
      }
    }
  }
}
